import React from "react";
import CheckIcon from "../../../assets/svg/check-icon";
import ChevronRightIcon from "../../../assets/svg/chevron-right-icon";
import { UseCaseItemProps } from "../CampaignBranchesDropdown";

const UseCaseItem: React.FC<UseCaseItemProps> = ({
  useCase,
  isSelected,
  selectedBranchCount,
  totalBranchCount,
  isFocused,
  onToggle,
  onBranchesClick,
  onMouseEnter,
  hasBranches,
}) => {
  return (
    <div
      role="option"
      aria-selected={isSelected}
      className={`
        flex items-center justify-between cursor-pointer border-b border-border-gray dark:border-border-gray-dk 
        last:border-b-0 transition-colors px-[14px] py-[10px] min-w-0
        ${
          isSelected
            ? "bg-selected-option-highlight dark:bg-selected-option-highlight-dk border-b-selected-option-highlight-border dark:border-b-selected-option-highlight-border-dk"
            : isFocused
            ? "bg-hover-effect dark:bg-hover-effect-dk"
            : "hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
        }
      `}
      onClick={onToggle}
      onMouseEnter={onMouseEnter}
    >
      <div className="flex items-center gap-[10px]">
        {/* Checkbox */}
        <div
          className={`shrink-0 w-[14px] h-[14px] border rounded-[3px] flex items-center justify-center ${
            isSelected
              ? "bg-verba-blue dark:bg-verba-blue-dk border-verba-blue dark:border-verba-blue-dk"
              : "border-gray-placeholder dark:border-gray-placeholder-dk bg-popper-bg dark:bg-popper-bg-dk"
          }`}
        >
          {isSelected && (
            <CheckIcon className="w-2.5 h-2.5 text-pure-white dark:text-pure-white-dk" />
          )}
        </div>

        {/* Label */}
        <span className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk select-none">
          {useCase.name}
        </span>
      </div>

      {/* Branch info */}
      {hasBranches && (
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            onBranchesClick();
          }}
        >
          <span className="text-[10px] font-medium text-gray-placeholder dark:text-gray-placeholder-dk">
            {selectedBranchCount}/{totalBranchCount} Branches
          </span>
          <ChevronRightIcon className="w-4 h-4 text-gray-placeholder dark:text-gray-placeholder-dk" />
        </div>
      )}
    </div>
  );
};

export default UseCaseItem;